import { Home as Page } from '@/components/home/Home';

export default function PageHome() {
	return <Page />;
	// return <Docs />;
}
